module.exports = __webpack_public_path__ + "img/ebay1.c695f9bb.png";